import type { RowExport } from '@/components/ui/table/exportRows'
import type { Transaction } from '@/modules/projects/stores'
import { transactionsColumns } from './columns'

interface ExportableColumn {
  accessorKey: keyof Transaction & string
  header: string
}

const isExportable = (column: object): column is ExportableColumn =>
  'accessorKey' in column &&
  'header' in column &&
  typeof column.header === 'string'

// The same columns the Transactions table exports, so both files match.
export const transactionsExport = (transactions: Transaction[]): RowExport => {
  const hasShareNumber = transactions.some(
    (transaction) => transaction.shareNumber,
  )
  const columns = transactionsColumns(hasShareNumber)
    .filter(isExportable)
    .map((column) => ({ key: column.accessorKey, label: column.header }))
  return {
    columns,
    rows: transactions as unknown as Array<Record<string, unknown>>,
  }
}
